import ywk from '@common/utils/ywk'

/** 获取角色数据
 * 获取角色数据
 * @param {*} param0
 */
export const setDomains = ({commit}) => {
  ywk.getJson('/api/v2/scopes', {}).then((res) => {
    if (res.error_code === 0) {
      commit('SETDOMAINS', res.domains)
    }
  })
}
